import React from 'react';

import { Button } from '@swyftx/aviary/atoms/Button';
import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { SelectItemData } from '@swyftx/aviary/atoms/Select';
import { Body } from '@swyftx/aviary/atoms/Typography';
import { ArrowChevronDown } from '@swyftx/aviary/icons/outlined';

import { cn } from '@shared/utils/lib/ui';

type Props = {
  disabled?: boolean;
  id: string;
  isError?: boolean;
  open?: boolean;
  placeholder?: string;
  selectedItem?: SelectItemData;
  spotlightElementId?: string;
  triggerClassName?: string;
  value?: string;
};

export const Trigger: React.FC<Props> = ({
  disabled,
  id,
  isError,
  open,
  placeholder,
  selectedItem,
  spotlightElementId,
  triggerClassName,
  value,
}) => (
  <div
    className={cn(
      'focus:focus-area-info flex w-full rounded-[8px] bg-color-background-surface-secondary px-12 py-8 hover:bg-color-background-neutral-hover focus:outline focus:outline-color-border-accent',
      {
        'focus-area-info !bg-color-background-surface-secondary outline outline-color-border-accent': open,
        'focus-area-error outline outline-color-border-error': isError,
        'cursor-default text-color-text-disabled hover:bg-color-background-surface-secondary': disabled,
      },
      triggerClassName,
    )}
  >
    <FlexLayout
      id={id}
      alignItems='center'
      justifyContent='space-between'
      className='h-full w-full leading-5'
      data-spotlightelementid={spotlightElementId}
    >
      <FlexLayout
        alignItems='center'
        justifyContent='start'
        spacing={12}
        className={value ? 'text-color-text-primary' : 'text-color-text-neutral'}
      >
        <FlexLayout direction='column' alignItems='start'>
          <Body
            size='medium'
            className={cn({
              'text-color-text-error': isError,
            })}
          >
            {selectedItem?.label || placeholder}
          </Body>
        </FlexLayout>
      </FlexLayout>
      <Button
        variant='ghost'
        layout='icon'
        size='sm'
        leadingIcon={<ArrowChevronDown className='h-16 w-16' />}
        disabled={disabled}
      />
    </FlexLayout>
  </div>
);
